import { withProfiler } from "@sentry/react";
import type { FC } from "react";

import type { Flipper } from "@shared/types/flipper";
import { ErrorBoundary, Providers } from "@unauthenticated/signupSignin/components";
import { OfficeSignUpPage as OfficeSignUpScene } from "@unauthenticated/signupSignin/scenes";

interface Props {
  emailRegex: string;
  currentCountry: string;
  flippers: Flipper[];
  newSSOErrors?: string;
  roleId: string;
  roleType: "Practitioner" | "Clerk";
  roleAttributes?: any;
  storeId: string;
  e2e: boolean;
}

const OfficeSignUpPage: FC<Props> = ({
  emailRegex,
  currentCountry,
  flippers,
  newSSOErrors,
  roleId,
  roleType,
  roleAttributes,
  storeId,
  e2e,
}) => {
  return (
    <Providers
      emailRegex={emailRegex}
      currentCountry={currentCountry}
      flippers={flippers}
      e2e={e2e}
    >
      <ErrorBoundary {...{ flippers, roleId, storeId, roleType }}>
        <OfficeSignUpScene
          roleAttributes={roleAttributes}
          roleType={roleType}
          roleId={roleId}
          newSSOErrors={newSSOErrors}
        />
      </ErrorBoundary>
    </Providers>
  );
};

const PatientInvitationPageWithProfiler = withProfiler(OfficeSignUpPage);
export { PatientInvitationPageWithProfiler as OfficeSignUpPage };
